import { Component, inject, OnInit, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { getAuthRedirectError } from './ensure-signed-in';

@Component({
  selector: 'app-auth-callback',
  template: `
    @if (error()) {
      <p>{{ error() }}</p>
    } @else {
      <p>Signing in...</p>
    }
  `
})
export class AuthCallback implements OnInit {
  private readonly msal = inject(MsalService, { optional: true });

  readonly error = signal<string | null>(null);

  private hasSignedInAccount(): boolean {
    const account = this.msal?.instance.getActiveAccount() ?? this.msal?.instance.getAllAccounts()[0];
    return !!account;
  }

  ngOnInit(): void {
    if (this.hasSignedInAccount()) {
      return;
    }

    window.setTimeout(() => {
      if (!this.hasSignedInAccount()) {
        this.error.set(getAuthRedirectError() ?? 'Sign-in did not complete.');
      }
    }, 0);
  }
}
